import React from 'react';
import { noop } from 'lodash';

import { NOT_ALLOWED_TYPES_FOR_BOOKMARK } from '@/features/bookmark/hooks/useContentBookmark';
import { useLongPressed } from '@/modules/content/context/LongPress';

import * as BaseCard from '../../../.';
import { BaseCardContent } from '../../../types';
import useOptions from '../../useOptions';
import OptionsWithBookmark from '../OptionsWithBookmark';

const LongPressWrapper: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<{ content: BaseCardContent }>>
> = ({ children, content }) => {
  const { isLongPress, off } = useLongPressed();

  const { contentId, contentType, name, publicAccessConfig } = content;

  const { items, createOnAction } = useOptions({
    contentId,
    contentType,
    contentName: name ?? undefined,
    onClose: off,
    publicAccessConfig,
  });

  const onAction = createOnAction(noop);

  if (contentId && contentType && !NOT_ALLOWED_TYPES_FOR_BOOKMARK.includes(contentType)) {
    return (
      <OptionsWithBookmark contentId={contentId} contentType={contentType}>
        {children}
      </OptionsWithBookmark>
    );
  }

  return (
    <>
      {children}
      <BaseCard.Options items={items} showOptions={isLongPress} onAction={onAction} onClose={off} />
    </>
  );
};

export default LongPressWrapper;
